import { ResolveFn } from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {GoldenTipService} from '../golden-tip.service';
import {Subscription} from 'rxjs';

export const goldenTipResolver: ResolveFn<Promise<void | Subscription>> = async (activatedRouteSnapshot) => {
  const slugParam = activatedRouteSnapshot.paramMap.get('slug');
  if (!slugParam) {
    return Promise.resolve();
  }
  return await inject(GoldenTipService).resolveBySlug(slugParam, RenderStrategy.PREFER_SERVER);
};
